import styled from "styled-components";
import { Button } from "antd";

export const StyledButton = styled(Button)<{
  $height?: number;
  $fontSize?: number;
}>`
  background: #1e3665;
  border-radius: 3px !important;
  padding: 0 4px !important;
  border: none;
  color: #fff;
  font-size: ${({ $fontSize }) =>
    $fontSize ? `${$fontSize}px` : "12px"} !important;
  max-height: ${({ $height }) =>
    $height ? `${$height}px` : "fit-content"} !important;
  line-height: 1.5715 !important;
  height: ${({ $height }) => ($height ? `${$height}px` : "24px")} !important;
  min-width: 60px !important;
  box-sizing: border-box;
  &:hover,
  &:focus {
    background: #365fa8;
  }
  &:active {
    background: #4472c4;
  }
  &:disabled,
  &.ant-btn-disabled {
    background: #bcbcbc !important;
    color: #fff !important;
    cursor: not-allowed;
  }
  .button-arrow-down-name {
    display: flex;
    align-items: center;
    height: ${({ $height }) =>
      $height ? `${$height - 2}px` : "24px"} !important;
    margin-right: 2px;
    margin-top: 0px !important;
  }
`;
